import { render } from "./ExpedientDetailRelatedExpedients.vue?vue&type=template&id=4648f65a"
import script from "./ExpedientDetailRelatedExpedients.vue?vue&type=script&lang=js"
export * from "./ExpedientDetailRelatedExpedients.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__